import React from "react";
import "./Faq.css";
import About_Banner_Component from "../about_us/about_banner/About_Banner_Component/About_Banner_Component";
import Faq_content from "./Faq_content/Faq_content";

function Faq() {
  return (
    <>
      <div className="Faq">
        <About_Banner_Component
          img="\assets\Image\FAQ\banner.png"
          title="Frequently Asked Questions"
          showBtn={false}
        />

        <Faq_content />
      </div>
    </>
  );
}

export default Faq;
